import { CloudSun, Compass, Heart, History, Moon, Sprout, Timer, type LucideIcon } from 'lucide-react';
import { Pill } from '../../components/ui/Pill';

const REASON_ICONS: Record<string, LucideIcon> = {
  Favoriet: Heart,
  'Lang niet gedaan': History,
  'Nog niet geprobeerd': Sprout,
  'Lekker weer voor buiten': CloudSun,
  'Past bij het weer': CloudSun,
  'Rustig voor de avond': Moon,
  'Past in je tijd': Timer,
};

/** Maximaal twee redenen als kleine pills met icoon ("Waarom nu"). */
export function ReasonPills({ reasons, className }: { reasons?: string[]; className: string }) {
  const list = (reasons ?? []).slice(0, 2);
  if (list.length === 0) return null;
  return (
    <ul className="flex flex-wrap gap-1.5" aria-label="Waarom nu">
      {list.map((r) => (
        <li key={r}>
          <Pill icon={REASON_ICONS[r] ?? Compass} className={className}>
            {r}
          </Pill>
        </li>
      ))}
    </ul>
  );
}
